/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import Constants from "../helpers/Constants";


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: window.location.origin.indexOf('localhost') !== -1 || window.location.origin.indexOf('dev') !== -1 ? "7ac6f29d-802d-4416-9b6f-a86ac77259fd" : window.location.origin.indexOf('acc') !== -1 ? "49b04400-279f-449b-a164-c6c8062716c4" : "93e55734-fd5f-421a-a014-90473e68d46f",
        redirectUri: window.location.origin.indexOf('localhost') !== -1 ? "http://localhost:8100" : window.location.origin.indexOf('dev') !== -1 ? "https://tritonopstst-dev.azurewebsites.net/" : window.location.origin.indexOf('acc') !== -1 ? "https://tritonoperations-acc.azurewebsites.net/" : window.location.origin.indexOf('ops.triton') !== -1 ? "https://ops.triton.damen.com/" : "https://reporter.triton.damen.com/",
        authority: window.location.origin.indexOf('localhost')!== -1 || window.location.origin.indexOf('dev') !== -1 ? "https://login.microsoftonline.com/f45bbe90-9957-4ed7-810f-11c382518756" : window.location.origin.indexOf('acc') !== -1 ? "https://login.microsoftonline.com/3eb8fc14-770c-4ab5-a44d-6151fcb833b2" : "https://login.microsoftonline.com/b4329e2f-88b3-47d5-82fa-1b4e3ce106cd",
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    // system: {
    //     loggerOptions: {
    //         loggerCallback: (level, message, containsPii) => {
    //             if (containsPii) {
    //                 return;
    //             }
    //             switch (level) {
    //                 case LogLevel.Error:
    //                     console.error(message);
    //                     return;
    //                 case LogLevel.Info:
    //                     console.info(message);
    //                     return;
    //                 case LogLevel.Verbose:
    //                     console.debug(message);
    //                     return;
    //                 case LogLevel.Warning:
    //                     console.warn(message);
    //                     return;
    //             }
    //         }
    //     }
    // }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
